import React from 'react';
import GlobalHeader from '../Fragments/GlobalHeader';

class NotFound extends React.Component {
    render() {
        return (
            <div>
                <GlobalHeader />
                <div className="container stepless">
                    <h1>Sorry, we couldn't find that page</h1>
                    <div className="form-group">
                        <div className="field-content">
                            <p>This might be because:</p>
                            <ul>
                                <li>You have typed an incorrect web address, or</li>
                                <li>the page you were looking for has been moved, updated or deleted.</li>
                            </ul>
                            <p><a href="/start">Click here to return</a></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NotFound;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/NotFound.js
 **/